
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.788 24.517h2.424v-3.031h3.031v-2.424h-3.031v-3.03h-2.424v3.03h-3.031v2.424h3.031v3.031z"}}),_c('path',{attrs:{"d":"M25.526 11.753L16 2.227l-9.526 9.526H1.025v6.418h1.337l2.975 9.927.234.769H26.43l.234-.769 2.975-9.927h1.337v-6.418zM16 5.268l6.485 6.485H9.515zm12.835 10.764h-.802l-.234.768-2.975 9.928H7.176L4.2 16.8l-.234-.768h-.802v-2.14h25.67z"}})])
          )
        }
      }
    